module.exports = __webpack_public_path__ + "files/1803b29b793c8049b9824ac98aa7d885.svg";